import { useEffect, useRef, useState } from "react";



export default function AboutSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" ref={sectionRef} className="w-full bg-white py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Top label */}
        <p className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-4">Who We Are</p>

        {/* Main layout */}
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-start">
          {/* Left: Title */}
          <div
            className={`lg:w-2/5 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          >
            <h2
              className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Expert Team Building
              <span className="block text-gray-400 font-light mt-1">Modern iOS Solutions</span>
            </h2>

            {/* Visual accent */}
            <div className="mt-10 relative rounded-2xl overflow-hidden w-full aspect-square max-w-sm">
              <img
                src="https://public.readdy.ai/ai/img_res/82a57d970b0241ad3de828f27fd946b5.jpg"
                alt="CUB SRL team workspace"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
          </div>

          {/* Right: Content */}
          <div
            className={`lg:w-3/5 transition-all duration-700 delay-200 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          >
            <div className="space-y-6 text-gray-600 text-base md:text-lg leading-relaxed max-w-xl">
              <p>
                <strong className="text-gray-900">CUB SRL</strong> is a dedicated team of iOS specialists with a passion for building applications that genuinely improve people&apos;s digital lives. Based in Romania, we combine deep technical expertise with a user-first design philosophy.
              </p>
              <p>
                Our flagship products — a powerful <strong className="text-gray-900">VPN</strong> and an intelligent <strong className="text-gray-900">Cleaner</strong> — are engineered to deliver real value: protecting user privacy, optimizing device performance, and creating seamless mobile experiences.
              </p>
              <p>
                We believe great software is built on trust, transparency, and relentless attention to detail. Every feature we ship is tested rigorously and designed to meet the highest standards of the iOS ecosystem.
              </p>
            </div>

            {/* Values */}
            <div className="mt-12 flex flex-wrap gap-3">
              {["Privacy First", "Performance Driven", "User Focused", "iOS Native", "Secure by Design"].map((tag) => (
                <span
                  key={tag}
                  className="px-4 py-1.5 rounded-full border border-gray-200 text-xs font-medium text-gray-600 bg-gray-50"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
